export default __webpack_public_path__ + "static/media/txt1_pc.f3f8f87a.png";